import { useState } from 'react';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  const [mobileDropdownOpen, setMobileDropdownOpen] = useState(false);

  return (
    <section id="categories" className="relative py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-50 text-primary-700 text-xs font-semibold uppercase tracking-wider mb-4">
            Shop by Category
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            Explore <span className="text-primary-600">Product Categories</span>
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            Browse our complete range of product categories. Click any category to explore items on our main website.
          </p>
        </div>

        {/* Mobile category dropdown */}
        <div className="md:hidden mb-6">
          <button
            onClick={() => setMobileDropdownOpen(!mobileDropdownOpen)}
            className="w-full flex items-center justify-between px-5 py-3.5 bg-background-100 rounded-xl border border-background-200/60 text-sm font-medium text-foreground-800 cursor-pointer"
          >
            <span className="flex items-center gap-2">
              <i className="ri-grid-fill text-primary-500"></i>
              Browse All Categories
            </span>
            <i className={`ri-arrow-down-s-line text-lg transition-transform ${mobileDropdownOpen ? 'rotate-180' : ''}`}></i>
          </button>
          {mobileDropdownOpen && (
            <div className="mt-2 bg-background-100 rounded-xl border border-background-200/60 overflow-hidden overflow-y-auto max-h-[60vh]">
              {categories.map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="flex items-center gap-3 px-5 py-3 text-sm text-foreground-700 hover:bg-background-200/40 hover:text-primary-600 transition-colors border-b border-background-200/40 last:border-0 cursor-pointer"
                  onClick={() => setMobileDropdownOpen(false)}
                >
                  <i className="ri-shopping-bag-3-line text-foreground-400"></i>
                  {cat.name}
                  <i className="ri-external-link-line ml-auto text-xs text-foreground-400"></i>
                </a>
              ))}
            </div>
          )}
        </div>

        {/* Desktop grid */}
        <div className="hidden md:grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col items-center justify-center p-4 md:p-5 bg-background-100 rounded-2xl border border-background-200/60 hover:border-primary-300/50 hover:bg-primary-50/30 transition-all duration-300 cursor-pointer"
            >
              <span className="w-10 h-10 md:w-12 md:h-12 rounded-xl bg-background-50 flex items-center justify-center mb-3 text-foreground-500 group-hover:text-primary-500 transition-colors">
                <i className="ri-shopping-bag-3-line text-lg md:text-xl"></i>
              </span>
              <span className="text-xs md:text-sm font-medium text-foreground-800 group-hover:text-primary-700 transition-colors text-center whitespace-nowrap">
                {cat.name}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}